module.exports = __webpack_public_path__ + "img/definir-empresa.5f77cade.svg";